import { useState } from "react";
import { Box, Collapse } from "@mui/material";
import type { IWorkspace } from "features/workspaces/types";
import type { IProject, IProjectsLanguages } from "features/projects/types";
import type { ValidationTemplates } from "features/languages/types/validation-templates";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { SelectValidationTemplate } from "./SelectValidationTemplate";
import { projectStyle } from "./styles";

const ProjectLanguage = ({
  projectLanguage,
  validationTemplates,
}: {
  projectLanguage: IProjectsLanguages;
  validationTemplates: ValidationTemplates;
}) => (
  <Box>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 2,
        pl: 8,
        borderTop: "1px solid #ccc",
      }}
    >
      {projectLanguage.languageId}
      <SelectValidationTemplate
        projectLanguageId={projectLanguage.id}
        validationTemplateId={projectLanguage.validationTemplateId}
        validationTemplates={validationTemplates}
      />
    </Box>
  </Box>
);

const Project = ({ project, validationTemplates }: { project: IProject; validationTemplates: ValidationTemplates }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Box sx={projectStyle}>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 2, cursor: "pointer" }}
        onClick={() => {
          setIsOpen(val => !val);
        }}
      >
        <Box sx={{ display: "flex", pr: 1 }}>
          <Box sx={{ width: 20, height: 20, rotate: isOpen ? "90deg" : "0deg", transition: "rotate 0.3s" }}>
            <ChevronRightIcon width={16} height={16} />
          </Box>
          <Box sx={{ pl: 2, fontWeight: "bold" }} component="span">
            {project.name}
          </Box>
        </Box>
      </Box>

      <Collapse in={isOpen}>
        {project.projectsLanguages.map((projectLanguage: IProjectsLanguages) => (
          <ProjectLanguage
            projectLanguage={projectLanguage}
            validationTemplates={validationTemplates}
            key={projectLanguage.id}
          />
        ))}
      </Collapse>
    </Box>
  );
};

export const Tree = ({
  workspace,
  validationTemplates,
}: {
  workspace: IWorkspace;
  validationTemplates: ValidationTemplates;
}) => (
  <>
    {workspace.projects.map(project => (
      <Project project={project} validationTemplates={validationTemplates} key={project.id} />
    ))}
  </>
);
